import React from 'react';
import Navbar from '../components/Navbar';
import { trackToolAction } from '../utils/metrics';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import moment from 'moment-timezone';
import { set } from 'date-fns';

dayjs.extend(utc);
dayjs.extend(timezone);

function UTCConverter() {
	const [usersTimeLabel, setUsersTimeLabel] = React.useState("Select UTC Time to Convert");
	const [usersTime, setUsersTime] = React.useState(new Date());
	const [results, setResults] = React.useState("");
	const [offset, setOffset] = React.useState("");
	const [timeZone, setTimeZone] = React.useState('America/New_York');
	const timeZones = moment.tz.names();
	const [datePickerTZ, setDatePickerTZ] = React.useState('UTC');

	const doUpdateTimezone = function(e) { setTimeZone(e.target.value); }
	const usersTimeChanged = function(e) { setUsersTime(e); }

	const doTimeConversion = function() {
		var time = usersTime;
		if (alignment === 'left') {
			var localTime = dayjs(time).tz(timeZone).format('MM/DD/YYYY HH:mm (h:mm A)');
			setResults("Local Time: " + localTime);
			setOffset("Offset: " + dayjs(time).tz(timeZone).utcOffset() / 60 + " Hours");
		} else if (alignment === 'right') {
			var utcTime = dayjs(time).utc().format('MM/DD/YYYY HH:mm (h:mm A)');
			setResults("UTC Time: " + utcTime);
			setOffset("Offset: " + dayjs(time).tz(timeZone).utcOffset() / 60 + " Hours");
		}
	}

	const [alignment, setAlignment] = React.useState('left');
	const handleChange = (event, newAlignment) => {
		setAlignment(newAlignment);
		if (event.target.value === 'left') {
			setUsersTimeLabel("Select UTC Time to Convert");
			setDatePickerTZ('UTC');
		} else if (event.target.value === 'right') {
			setUsersTimeLabel("Select Local Time to Convert");
			setDatePickerTZ(timeZone);
		}
	};
	const control = { value: alignment, onChange: handleChange, exclusive: true };
	const converTime = function() { trackToolAction('/utcconverter', 'UTC Converter'); doTimeConversion(); };

	const sortedTimeZones = timeZones.sort((a, b) => {
		if (a.startsWith('US/')) return -1;
		if (b.startsWith('US/')) return 1;
		if (a === 'America/New_York') return -1;
		if (b === 'America/New_York') return 1;
		if (a.includes("America/") && !b.includes("America/")) return -1;
		if (!a.includes("America/") && b.includes("America/")) return 1;
		return a.localeCompare(b);
	});

	return (
		<>
			<Navbar pageTitle="UTC Converter" />
			<Container maxWidth="md" sx={{ py: 4 }}>

				<Box sx={{ mb: 3 }}>
					<Typography variant="h5" sx={{ fontWeight: 800, color: '#0f172a', letterSpacing: '-0.4px' }}>
						UTC Converter
					</Typography>
					<Typography sx={{ color: '#64748b', mt: '6px', fontSize: '15px' }}>
						Quickly convert between UTC and local time.
					</Typography>
				</Box>

				<Paper elevation={0} sx={{
					borderRadius: '14px',
					boxShadow: '0 1px 3px rgba(0,0,0,.07), 0 4px 16px rgba(0,0,0,.05)',
					p: '26px 26px 22px', mb: 2.5,
				}}>
					<Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#374151', mb: 1 }}>
						Timezone
					</Typography>
					<Select
						value={timeZone}
						fullWidth
						onChange={doUpdateTimezone}
						sx={{ mb: 2.5, borderRadius: '8px' }}
					>
						{sortedTimeZones.map((tz, index) => (
							<MenuItem key={index} value={tz}>{tz}</MenuItem>
						))}
					</Select>

					<ToggleButtonGroup size="large" {...control} aria-label="Direction" fullWidth sx={{ mb: 2.5 }}>
						<ToggleButton value="left" key="left">UTC to Local Time</ToggleButton>
						<ToggleButton value="right" key="right">Local Time to UTC</ToggleButton>
					</ToggleButtonGroup>

					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<DemoContainer components={['DateTimePicker']}>
							<DateTimePicker timezone={datePickerTZ} label={usersTimeLabel} onChange={usersTimeChanged} />
						</DemoContainer>
					</LocalizationProvider>

					{(results || offset) && (
						<Box sx={{ mt: 2.5, p: '16px 20px', bgcolor: '#f5f3ff', borderRadius: '10px', border: '1px solid #ddd6fe' }}>
							{results && (
								<Typography sx={{ fontSize: '15px', color: '#1e293b', fontWeight: 700 }}>{results}</Typography>
							)}
							{offset && (
								<Typography sx={{ fontSize: '13px', color: '#6d28d9', mt: '4px' }}>{offset}</Typography>
							)}
						</Box>
					)}

					<Button
						fullWidth variant="contained"
						onClick={converTime}
						sx={{
							mt: 2.5, p: '10px 20px', bgcolor: '#6d28d9',
							fontSize: '14px', fontWeight: 600, borderRadius: '8px',
							'&:hover': { bgcolor: '#5b21b6' },
						}}
					>
						Convert Time
					</Button>
				</Paper>
			</Container>
		</>
	);
}

export default UTCConverter;
